import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { HealthTopicContent } from "@/components/health/HealthSourceInfo";
import { healthSections, healthTopics, MEDICAL_DISCLAIMER } from "@/data/healthReferences";

export default function NutritionSources() {
  return <div className="mx-auto max-w-3xl space-y-6 px-4 py-6 pb-28 text-white" data-testid="nutrition-sources-page">
    <Link to="/meals" className="inline-flex items-center gap-2 py-2 text-sm text-sky-300 underline rounded focus-visible:ring-2 focus-visible:ring-sky-400"><ArrowLeft aria-hidden="true" className="h-4 w-4" />Meals</Link>
    <header className="space-y-3">
      <h1 className="font-display text-2xl sm:text-3xl font-bold">Nutrition Information &amp; Sources</h1>
      <p className="text-sm leading-relaxed text-slate-300">Understand your estimates, where food values come from, and what the research supports. These explanations describe the current app; saved targets and records are unchanged.</p>
    </header>
    <nav aria-label="Nutrition source sections" className="flex flex-wrap gap-x-4 gap-y-2">
      {healthSections.map(section => <a key={section.id} href={`#${section.id}`} className="py-1 text-sm text-sky-300 underline rounded focus-visible:ring-2 focus-visible:ring-sky-400">{section.title}</a>)}
    </nav>
    {healthSections.map(section => <section key={section.id} id={section.id} className="scroll-mt-24 rounded-2xl border border-slate-800 bg-[#020817] p-4 sm:p-6 space-y-6">
      <h2 className="text-xl font-semibold">{section.title}</h2>
      {section.topics.map(topic => <article key={topic} className="space-y-3">
        <h3 className="font-semibold text-sky-200">{healthTopics[topic].title}</h3>
        <p className="text-sm leading-relaxed text-slate-300">{healthTopics[topic].summary}</p>
        <HealthTopicContent topic={topic} />
      </article>)}
      {section.id === "medical-disclaimer" && <p className="text-sm leading-relaxed text-slate-300">{MEDICAL_DISCLAIMER}</p>}
    </section>)}
  </div>;
}
